import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    flex: 1,
    overflow: 'hidden',
    borderRadius: 0,
    height: '100%'
    // borderLeft: '1px solid rgba(0, 0, 0, 0.12)'
  },
  messageList: {
    position: 'relative',
    overflowY: 'auto',
    height: '100%',
    ...theme.scrollbarStyles,
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.gray_50.main
    // backgroundImage:
    //   theme.mode === 'light'
    //     ? `url(${whatsBackground})`
    //     : `url(${whatsBackgroundDark})`
    // backgroundColor: theme.palette.chatlist //DARK MODE PLW DESIGN//
  },
  messageInputWrapper: {
    display: 'flex',
    alignItems: 'center'
    // borderTop: '1px solid rgba(0, 0, 0, 0.12)'
  },
  inputArea: {
    // position: 'relative',
    // height: 'auto',
    padding: '10px 0'
  },
  input: {
    flex: 1,
    display: 'flex',
    borderRadius: '8px',
    '& .MuiOutlinedInput-root': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.gray_50.main,
      borderRadius: '8px'
    },
    '& .MuiOutlinedInput-multiline': {
      padding: '14px !important'
    },
    '& input': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main,
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.gray_50.main,
      padding: '12px'
    },
    '& textarea': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main,
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.gray_50.main
    }
  },
  buttonSend: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.blue_300.main,
    color: theme.palette.white_100.main,
    borderRadius: 8,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: theme.palette.blue_400.main,
      boxShadow: 'none'
    }
  },
  boxLeft: {
    padding: '10px',
    margin: '10px',
    position: 'relative',
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.dark_700.main : theme.palette.white_100.main,
    maxWidth: 300,
    borderRadius: 10,
    borderTopLeftRadius: 0
    // border: '1px solid rgba(0, 0, 0, 0.12)'
  },
  boxRight: {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px',
    margin: '10px 10px 10px auto',
    // position: 'relative',
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.dark_700.main : theme.palette.blue_50.main, //DARK MODE PLW DESIGN//
    // textAlign: 'right',
    maxWidth: 300,
    borderRadius: 10,
    borderBottomRightRadius: 0
    // border: '1px solid rgba(0, 0, 0, 0.12)'
  },
  sendMessageIcons: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  uploadInput: {
    display: 'none'
  },
  circleLoading: {
    color: theme.palette.green_200.main,
    opacity: '70%',
    position: 'absolute',
    top: '20%',
    left: '50%',
    marginLeft: -12
  },
  viewMediaInputWrapper: {
    display: 'flex',
    padding: '10px 13px',
    position: 'relative',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.dark_700.main : theme.palette.blue_300.main
    // borderTop: '1px solid rgba(0, 0, 0, 0.12)'
  },
  downloadMedia: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'inherit',
    padding: 10
  },
  messageMedia: {
    objectFit: 'cover',
    // width: 250,
    height: 200,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8
  },
  recorderWrapper: {
    display: 'flex',
    alignItems: 'center',
    alignContent: 'middle',
    justifyContent: 'flex-end'
  },
  cancelAudioIcon: {
    color: 'red'
  },
  audioLoading: {
    color: theme.palette.green_200.main,
    opacity: '70%'
  },
  sendAudioIcon: {
    color: 'green'
  },
  message: {
    overflow: 'hidden',
    wordWrap: 'break-word',
    whiteSpace: 'normal',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  nameSender: {
    width: '100%',
    display: 'flex',
    fontWeight: '600',
    fontSize: '12px',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  messageTime: {
    textAlign: 'right',
    color: theme.palette.gray_400.main,
    fontSize: '11px'
  },
  fileInput: {
    '& svg': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    }
  }
}))
